/**
 * by constructing the types from a const array, we still get the benefits of a Type while
 * also having a data structure available at runtime.
 * https://stackoverflow.com/a/64174790/981556
 *
 * One use case is to allow dynamic controls in storybook.
 */

export const buttonAppearance = <const>['outline', 'solid', 'transparent'];
export type ButtonAppearance = typeof buttonAppearance[number];

export const buttonPalette = <const>['brand', 'destructive', 'inverse', 'neutral', 'success'];
export type ButtonPalette = typeof buttonPalette[number];
